<template>
<CModal @mtdclosemodal="mtdclosemodal" :show="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="modalSize" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div class="row mx-0  px-0">

        <div class="row mx-0 px-0" v-if="data.length > 0">
            <div class="col-xl-3 mb-1  px-1 " v-for="(item,index) in data" :key="index">
                <div class="text-center  text-white rounded rounded-2 btn-asistencial text-xxs h-100 border border-main border-3" @click="add(item)">
                    <button type="button" class="btn w-100 text-xs h-100 ">
                        {{ item.name ? item.name : '-'}}
                    </button>
                </div>
            </div>
        </div>
        <div class="text-center fw-bold" v-else>
            <span>No hay Registros</span>
        </div>

    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
</CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";

export default {
    name: "c--modal-orden-listadoMonturas",

    data() {
        return {
            swal: null,
            data: [],
            windowWidth: window.innerWidth
        }
    },
    components: {
        CModal,
        SweetAlert
    },
    computed: {
        modalSize() {
            return this.windowWidth >= 992 ? 'xl' : 'md';
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    props: {
        title: String,
        boo_modal: Boolean,
        num: {
            type: Number,
            default: null
        },
        search: {
            type: String,
            default: ''
        },
    },
    watch: {
        num: {
            handler: function (newValue) {
                if (newValue != null) {
                    this.mtdTypeMoon();
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdclosemodal() {
            this.mtdClear();
            this.$emit('closeModal');
        },

        mtdClear() {
            this.data = []
        },

        mtdTypeMoon: function () {
            this.get({
                url: this.$store.getters.get__url + "/ordenTrabajo/mtdTypeMoon/" + this.search,
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                if(response.statusCode == 200){
                    this.data = response.data;
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        add: function (item) {
            this.$emit('add', item, this.num);
            this.mtdclosemodal();
        },

        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    }
}
</script>
